import PrintersDataTable from "../../../components/dataTable/tables/PrintersDataTable";
import { useAuthContext } from "../../../context/AuthContext";
import { StyledFlexColumn } from "../../../styles/LayoutStyles";
import { StyledCompanyId } from "./PrintersPageStyles";

function PrintersPageView() {
  const authContext = useAuthContext();

  return (
    <StyledFlexColumn>
      <StyledCompanyId>
        Company ID:{" "}
        {authContext.auth.user?.company?.printer_company_id || "N/A"}
      </StyledCompanyId>

      <PrintersDataTable />
    </StyledFlexColumn>
  );
}

export default PrintersPageView;
